import { useContext as t } from "react";
import { ThemeContext as o } from "../config/theme/ThemeProvider.js";
const n = () => {
  const e = t(o);
  if (!e)
    throw new Error("useTheme must be used within a ThemeProvider");
  return e;
};
export {
  n as useTheme
};
